import { ButtonProps } from '@/components/buttons/button/Button'
import Dropdown from '@/components/dropdown'
import { FC, MouseEvent } from 'react'

export type OptionsButton = {
  variant?: ButtonProps['variant']
  onClick: (event: MouseEvent) => void
  label?: string
  className?: string
  isDisabled?: boolean
  isLoading?: boolean
}

export interface FooterProps {
  optionsConfirmButton?: OptionsButton
  optionsCancelButton?: OptionsButton
  className?: string
}

export const _Footer: FC<FooterProps> = ({
  className,
  optionsConfirmButton,
  optionsCancelButton
}) => {
  return (
    <Dropdown.Footer
      className={className}
      confirmLabel={optionsConfirmButton?.label}
      isDisabledConfirm={optionsConfirmButton?.isDisabled}
      isLoadingConfirm={optionsConfirmButton?.isLoading}
      onConfirm={optionsConfirmButton?.onClick}
      isDisabledReset={optionsCancelButton?.isDisabled}
      isLoadingReset={optionsCancelButton?.isLoading}
      onReset={optionsCancelButton?.onClick}
      resetLabel={optionsCancelButton?.label}
    />
  )
}
